import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import SliderRangeTime from "../../../../components/SliderRangeTime";

//Actions
import {
    createClipRequestRequest,
    clearRedux,
} from 'Redux/actions';

//Helpers
import { getDateFormatted } from 'Core/data/Helpers';

//Styles
import './index.scss';

const CreateClipRequest = (props) => {
    /* const { tableRef, single, getDevice } = props; */
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef(null);
    //Local States
    const [maximumDuration, setMaximumDuration] = useState(null);
    const [currentDate, setCurrentDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [duration, setDuration] = useState(null);
    const [error, setError] = useState(null);


    //Redux states
    const { loading, openModal, result, current, } = useSelector(state => state.createClipRequestRedux);

    const { deviceId, timezone } = useSelector(state => state.deviceInfoRedux);

    const closeModal = () => {
        dispatch(dispatch(clearRedux("CREATE_CLIP_REQUEST")));
        setMaximumDuration(null)
        setCurrentDate(null);
        setStartDate(null);
        setDuration(null);
        setEndDate(null);
        setError(null);
    }

    const applyChanges = () => {
        let configStartDate = moment(startDate).utc().unix()
        let configEndDate = moment(endDate).utc().unix()
        let currentStartDate = moment(currentDate?.formatStart).utc().unix()
        let currentEndDate = moment(currentDate?.formatEnd).utc().unix()

        let validationOne = isNumberBetween(configStartDate, currentStartDate, currentEndDate)
        let validationTwo = isNumberBetween(configEndDate, currentStartDate, currentEndDate)
        if (!validationOne) {
            setError(messages['create_clip_error_range'])
            return
        } else if (!validationTwo) {
            setError(messages['create_clip_error_range'])
            return
        } else {
            setError(null)
        }

        let newStartDate = moment(startDate).utc();
        let newEndDate = moment(endDate).utc();
        let payload = {
            unitId: deviceId,
            dateRange: {
                start: newStartDate.format(),
                end: newEndDate.format(),
            }
        }
        dispatch(createClipRequestRequest(payload))
    }

    const handleOnChangeTime = (value) => {
        let formatValue = `${moment(value).utc().unix()}000`
        let initial = moment(+formatValue)
        if (timezone) {
            initial.tz(timezone)
        }
        setStartDate(initial)
        let momentDate = moment(initial)
        momentDate = momentDate.add(duration, 'seconds');
        setEndDate(momentDate)
    }

    const getSecondsDifference = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        const difference = momentDate1.diff(momentDate2, 'seconds');
        return Math.abs(difference);
    };

    const isNumberBetween = (num, num1, num2) => {
        if (num >= num1 && num <= num2) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        if (result) {
            if (result?.id) {
                NotificationManager.success(
                    messages['create_clip_success_message'],
                    messages['create_clip_request_title'],
                    3000
                );
                closeModal();
            }
            if (result?.error) {
                let message = messages['create_clip_error_clip']
                let validateClip = result?.error?.includes("already exists")
                if (validateClip) {
                    message = messages['create_clip_already_exists']
                }
                NotificationManager.error(
                    message,
                    messages['create_clip_request_title'],
                    3000
                );
                clearRedux("CREATE_CLIP_REQUEST", { error: null })
            }
        }
        return () => {
            closeModal()
            clearRedux("CREATE_CLIP_REQUEST")
        }
    }, [result])

    useEffect(() => {
        if (current) {
            let date = {
                start: getDateFormatted(current[0], "date", "datetime", null, timezone),
                end: getDateFormatted(current[1], "date", "datetime", null, timezone),
                formatStart: moment(current[0]),
                formatEnd: moment(current[1])
            }

            let initial = moment(current[0])
            if (timezone) {
                initial.tz(timezone)
            }

            const secondsDifference = getSecondsDifference(current[0], current[1])
            setMaximumDuration(secondsDifference)
            if (secondsDifference) {
                if (secondsDifference > 300) {
                    setDuration(300)
                    let momentDate = moment(current[0]);
                    if (timezone) {
                        momentDate = momentDate.tz(timezone)
                    }
                    momentDate = momentDate.add(300, 'seconds');
                    setEndDate(momentDate)
                } else {
                    let currentEndDate = moment(current[1])
                    setDuration(secondsDifference)

                    if (timezone) {
                        currentEndDate = currentEndDate.tz(timezone)
                    }
                    setEndDate(currentEndDate)
                }
            }
            setStartDate(initial)
            setCurrentDate(date)
        }
    }, [current])

    useEffect(() => {
        if (startDate && endDate && currentDate.formatStart && currentDate.formatEnd) {
            let configStartDate = moment(startDate).utc().unix()
            let configEndDate = moment(endDate).utc().unix()
            let currentStartDate = moment(currentDate?.formatStart).utc().unix()
            let currentEndDate = moment(currentDate?.formatEnd).utc().unix()

            let validationOne = isNumberBetween(configStartDate, currentStartDate, currentEndDate)
            let validationTwo = isNumberBetween(configEndDate, currentStartDate, currentEndDate)
            if (!validationOne) {
                setError(messages['create_clip_error_range'])
            } else if (!validationTwo) {
                setError(messages['create_clip_error_range'])
            } else {
                setError(null)
            }

        }
    }, [startDate, endDate, currentDate])

    return (
        <Modal
            open={openModal}
            title={messages['create_clip_request_title']}
            handleClose={(e) => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30, height: '80vh' }}>
                    <span style={{ fontWeight: 700 }}>{messages['create_clip_range']}</span>
                    {
                        currentDate && <p style={{ marginTop: 5, marginBottom: 20 }}>{`${currentDate?.start} - ${currentDate?.end}`}</p>
                    }
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        {
                            startDate &&
                            <SliderRangeTime
                                date={moment(startDate).format("MMM DD YYYY h:mm:ss")}
                                onApply={(item) => { handleOnChangeTime(item) }}
                                selectedTime={startDate}
                                timezone={timezone}
                            />
                        }
                        <div style={{ marginTop: 5 }}>
                            <label style={{ marginRight: '20px', fontWeight: 'bold', fontSize: '14px', color: '#000000', cursor: 'pointer' }}>{messages['create_clip_end_date']}</label>
                            <label style={{ color: '#000000', cursor: 'pointer' }}>{endDate ? endDate.format("MMM DD YYYY h:mm:ss") : ''}</label>
                        </div>
                        {
                            error &&
                            <div style={{ marginTop: 5 }}>
                                <small class="text-danger">{error}</small>
                            </div>
                        }

                        <div style={{ marginTop: 7 }} className="create-clip-input">
                            <Input
                                type="number"
                                label={messages['create_clip_duration']}
                                placeholder={messages['create_clip_duration']}
                                value={duration}
                                onChange={(value) => {
                                    let currentStarDate = startDate
                                    if (value) {
                                        let momentDate = moment(currentStarDate);
                                        momentDate = momentDate.add(value, 'seconds');
                                        setEndDate(momentDate)
                                    }
                                    setDuration(value)
                                }}
                                required
                                requiredMessage={messages['required_field']}
                                max={maximumDuration > 300 ? 301 : maximumDuration + 1}
                                min={5}
                                maxMessage={`${messages['create_clip_max']} ${maximumDuration > 300 ? 300 : maximumDuration}`}
                                minMessage={`${messages['create_clip_min']} 5`}
                            />
                        </div>

                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className={"btn-cancel"}
                    onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                    }}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={(e) => {
                        e.preventDefault();
                        formRef?.current?.submit()
                    }}
                    disabled={error}
                >
                    {messages['create_clip_get_clip']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateClipRequest;